<!-- create a template for an SVG ICON -->
<template>
<!-- Generator: Adobe Illustrator 27.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" baseProfile="tiny" class="dipper_svg_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px" y="0px" viewBox="0 0 189 189" overflow="visible" xml:space="preserve" >
<path
  :class='["circle", fill ? "filled" : "", selected ? "selected" : ""]'
  d="M17.9,35.9L17.9,35.9
	C9.3,35.2,3.1,27.4,4.1,18.7l0,0c0.5-4.2,2.6-8.1,5.8-10.9s7.4-4.1,11.6-3.7l0,0c8.6,0.7,14.8,8.5,13.8,17.2l0,0
	C34.3,30.1,26.5,36.6,17.9,35.9z"/>
<path
  :class='["circle", fill ? "filled" : "", selected ? "selected" : ""]'
  d="M154.3,132.7L154.3,132.7
	c-1.5-8.8,4.1-17.1,12.6-18.7l0,0c4.1-0.7,8.2,0.2,11.6,2.7c3.4,2.4,5.7,6.2,6.4,10.4l0,0c1.5,8.8-4.1,17.1-12.6,18.7l0,0
	C163.8,147.3,155.8,141.4,154.3,132.7z"/>
<path 
  :class='["circle", fill ? "filled" : "", selected ? "selected" : ""]'
  d="M58.1,128.9L58.1,128.9
	c2-8.7,10.4-14,18.8-11.9l0,0c4,1,7.5,3.6,9.6,7.3c2.1,3.7,2.8,8,1.8,12.2l0,0c-2,8.7-10.4,14-18.8,11.9l0,0
	C61.2,146.3,56.1,137.6,58.1,128.9z"/>
<path 
  :class='["circle", fill ? "filled" : "", selected ? "selected" : ""]'
  d="M114.1,169.3L114.1,169.3
	c0-8.9,7-16.1,15.5-16.1l0,0c4.1,0,8.1,1.7,11,4.7s4.5,7.1,4.5,11.4l0,0c0,8.9-7,16.1-15.5,16.1l0,0
	C121.1,185.5,114.1,178.2,114.1,169.3z"/>
<path 
  :class='["circle", fill ? "filled" : "", selected ? "selected" : ""]'
  d="M78.2,75L78.2,75
	c3-8.3,12-12.5,20-9.3l0,0c3.8,1.5,7,4.6,8.6,8.5c1.7,3.9,1.8,8.3,0.4,12.3l0,0c-3,8.3-12,12.5-20,9.3l0,0
	C79.1,92.7,75.1,83.3,78.2,75z"/>
<path 
  :class='["circle", fill ? "filled" : "", selected ? "selected" : ""]'
  d="M54.4,39.1L54.4,39.1
	c0-8.9,7-16.1,15.5-16.1l0,0c4.1,0,8.1,1.7,11,4.7s4.5,7.1,4.5,11.4l0,0c0,8.9-7,16.1-15.5,16.1l0,0C61.4,55.2,54.4,48,54.4,39.1z"
	/>
<path :class='["line", selected ? "selected" : ""]' d="M35.3,21.3L59,27.7"/>
<path :class='["line", selected ? "selected" : ""]' d="M81,50.5L86.3,66"/>
<path :class='["line", selected ? "selected" : ""]' d="M87.2,95.8l-10.3,21.2"/>
<path :class='["line", selected ? "selected" : ""]' d="M88.3,136.5l30.4,21.4"/>
<path :class='["line", selected ? "selected" : ""]' d="M140.7,157.9l20-14.9"/>
<path :class='["line", selected ? "selected" : ""]' d="M156.8,120.7l-49.6-34.2"/>

</svg>

  
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ConstellationIcon",

  data() {
    return {
    };
  },

  props: {
    width: {
      type: String,
      required: false,
      default: "100%",
    },
    height: {
      type: String,
      required: false,
      default: "100%",
    },

    color: {
      type: String,
      required: false,
      default: "white",
    },

    fill: {
      type: Boolean,
      required: false,
      default: false,
    },
    
    fillColor: {
      type: String,
      required: false,
      default: null,
    },

    selected: {
      type: Boolean,
      required: false,
      default: false,
    },

    selectedStyle: {
      type: String,
      required: false,
      default: "",
    }
  },


  watch: {
    active: function (val) {
      console.log("active changed to: " + val);
    },
  },

  computed: {
    computedFillColor() {
      return this.fillColor ? this.fillColor : this.color;
    }
  }
  
});

</script>

<style style lang="less">
.dipper_svg_icon {
  width: v-bind(width);
  
  
.circle {
  fill-rule:"evenodd";
  stroke-width: 7px ;
  stroke-miterlimit:10;
  stroke: v-bind(color);
  fill: none;
}

.line {
  stroke: v-bind(color);
  stroke-width: 7;
  stroke-miterlimit: 10;
}

.filled {
  fill: v-bind(computedFillColor);
}
}


</style>